import { FlexBox, Text, Title } from "@smoothincorg/smooth-ui"
import { useState } from "react"
import { useProposalsSearchHousesSWR } from "src/features/user/components/SearchHouses/SearchHouses"

const Tags = (props: { items: string[]; title: string }) => (
  <div
    style={{
      marginBottom: "10px",
      marginTop: "10px",
    }}
  >
    <strong
      style={{
        fontSize: "14px",
        fontWeight: "bold",
      }}
    >
      {props.title}
    </strong>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      {props.items.length === 0 ? (
        <span
          style={{
            fontSize: "12px",
          }}
        >
          なし
        </span>
      ) : (
        props.items.map((s) => (
          <span
            key={s}
            style={{
              backgroundColor: "#e5e5e5",
              display: "block",
              padding: "3px 4px",
              margin: "6px 3px",
              textAlign: "center",
              borderRadius: "5px",
              fontSize: "13px",
            }}
          >
            {s}
          </span>
        ))
      )}
    </div>
  </div>
)

export const NoBypassUserSearchHouse = (props: { proposalId: number }) => {
  const { data: searchHouses, isValidating } = useProposalsSearchHousesSWR(props.proposalId)
  const searchHouse = searchHouses?.[searchHouses.length - 1]
  const [showAll, setShowAll] = useState(false)

  if (isValidating) {
    return (
      <div className={`main-examination-score__row`}>
        <Text color="red">Loading...</Text>
      </div>
    )
  }

  if (!searchHouse) {
    return (
      <div className={`main-examination-score__row`}>
        <Text color="red">お部屋探し条件データが見つかりませんでした</Text>
      </div>
    )
  }

  return (
    <FlexBox className={`main-examination-score__row`} alignItems="center" flexWrap="wrap">
      <Title as="h3" size={14} weight="bold">
        ※ブツなしなし
      </Title>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: "10px",
        }}
      >
        <Text size={14} style={{ marginRight: "10px" }}>{`初期費用概算: ${
          searchHouse.rentLower * 5
        }~${searchHouse.rentUpper * 5} 円`}</Text>
        <Text
          size={14}
          style={{ marginRight: "10px" }}
        >{`希望家賃: ${searchHouse.rentLower}~${searchHouse.rentUpper} 円`}</Text>
        <Text size={14}>{`引越希望時期: ${
          searchHouse.movingTargetOn ? searchHouse.movingTargetOn : "データなし"
        }`}</Text>
      </div>
      <div
        role="button"
        onClick={() => setShowAll(!showAll)}
        style={{
          maxHeight: showAll ? "100%" : "200px",
          overflow: "hidden",
          transition: "max-height 0.5s ease",
          flexDirection: "column",
          cursor: "pointer",
        }}
      >
        <Tags items={[searchHouse.prefecture]} title="都道府県" />
        <Tags items={searchHouse.targetCities || []} title="希望エリア" />
        <Tags items={searchHouse.stations || []} title="希望駅" />
      </div>
    </FlexBox>
  )
}
